<template>
  <v-app-bar
    app
    flat
    clipped-left
    :style="{
      background: 'linear-gradient(90deg, #0080C5 46.63%, #09B582 100%)',
    }"
  >
    <v-btn icon class="ml-2" :href="route('home', stand.id)">
      <v-avatar size="40" color="white" class="pa-2">
        <img
          src="/images/logo-expopack.png"
          alt="Logo EXPO PACK"
          style="width: 100%; height: 100%; object-fit: contain"
        /> </v-avatar
    ></v-btn>
    <v-toolbar-title
      class="text-white font-weight-black d-none d-sm-none d-md-flex"
    >
      {{ $t("titulo") }}
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <!-- MENÚ CONTACTO -->
    <v-menu offset-y>
      <template #activator="{ props }">
        <v-btn
          text
          class="mx-2 d-none d-xl-flex d-lg-flex text-white font-weight-bold"
          v-bind="props"
        >
          {{ $t("appbar.contacto.titulo") }}
        </v-btn>
      </template>
      <v-card width="400">
        <v-card-title class="text--text text-uppercase">
          {{ $t("appbar.contacto.titulo") }}
        </v-card-title>
        <v-card-text style="background-color: #f2f2f3" class="pt-2">
          <v-list :min-width="300" bg-color="background">
            <v-list-subheader class="text-uppercase primary--text">{{
              $t("appbar.contacto.expositor")
            }}</v-list-subheader>

            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="primary" class="me-2">
                  mdi-email-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text"
                >atencionexpositor@expopack.com.mx</v-list-item-title
              >
              <v-list-item-subtitle class="text-caption">{{
                $t("correo")
              }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="primary" class="me-2">
                  mdi-phone-hangup-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text"
                >+52 (55) 5545 4254 ext 128</v-list-item-title
              >
              <v-list-item-subtitle class="text-caption">{{
                $t("telefono")
              }}</v-list-item-subtitle>
            </v-list-item>

            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="primary" class="me-2">
                  mdi-email-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text"
                >atencionexpositor2@expopack.com.mx</v-list-item-title
              >
              <v-list-item-subtitle class="text-caption">{{
                $t("correo")
              }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="primary" class="me-2">
                  mdi-phone-hangup-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text"
                >+52 (55) 5545 4254 ext 129</v-list-item-title
              >
              <v-list-item-subtitle class="text-caption">{{
                $t("telefono")
              }}</v-list-item-subtitle>
            </v-list-item>

            <v-divider class="my-2"></v-divider>

            <v-list-subheader class="primary--text">{{
              $t("appbar.contacto.pmmi")
            }}</v-list-subheader>

            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="secondary" class="me-2">
                  mdi-email-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text">{{
                constants.contactEmail
              }}</v-list-item-title>
              <v-list-item-subtitle class="text-caption">{{
                $t("correo")
              }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="secondary" class="me-2">
                  mdi-phone-hangup-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text">{{
                constants.contactPhone
              }}</v-list-item-title>
              <v-list-item-subtitle class="text-caption">{{
                $t("telefono")
              }}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="d-flex flex-row justify-center"
          ><v-btn color="secondary" variant="outlined" class="font-weight-bold">
            {{ $t("boton-cerrar") }}
          </v-btn></v-card-actions
        >
      </v-card>
    </v-menu>

    <!-- Search Button -->
    <circular-icon-button
      icon="mdi-magnify"
      icon-color="secondary"
      @click="abrirBuscador"
      v-if="
        [
          'administrador',
          'expositor',
          'afiliado',
          'operador',
          'proveedor',
          'operador limitado',
          'decorador',
          'capacitador',
          'coordinador',
        ].includes(user.roles[0].name)
      "
    />

    <!-- Notification Bell -->
    <!-- <notifications-dialog
            :stand="stand"
            :unread-count="unreadNotifications"
            @unreadCountUpdated="updateUnreadCount"
            ref="notificationsDialogRef"
        />-->

    <!-- MENÚ IDIOMA -->
    <div class="d-none d-xl-flex d-lg-flex">
      <v-menu offset-y>
        <template #activator="{ props }">
          <v-btn
            fab
            small
            elevation="0"
            color="white"
            class="mx-2 circular-btn"
            style="width: 40px; height: 40px; min-width: 40px"
            v-bind="props"
          >
            <span
              class="font-weight-bold"
              style="font-size: 14px; color: #09b582"
              >{{ locale.includes("es") ? "ES" : "EN" }}</span
            >
          </v-btn>
        </template>

        <v-list :max-width="211">
          <!-- Spanish -->
          <v-list-item :href="route('locale', 'es')" link>
            <template v-slot:prepend>
              <v-avatar color="secondary" class="white--text" size="32">
                <span style="font-size: 14px; font-weight: bold">ES</span>
              </v-avatar>
            </template>
            <v-list-item-title class="text--text">{{
              $t("appbar.espaniol")
            }}</v-list-item-title>
          </v-list-item>

          <v-divider class="my-2"></v-divider>

          <!-- English -->
          <v-list-item :href="route('locale', 'en')" link>
            <template v-slot:prepend>
              <v-avatar color="secondary" class="white--text" size="32">
                <span style="font-size: 14px; font-weight: bold">EN</span>
              </v-avatar>
            </template>
            <v-list-item-title class="text--text">{{
              $t("appbar.ingles")
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <!-- Logout Button -->
    <circular-icon-button
      icon="mdi-logout-variant"
      icon-color="secondary"
      link
      :href="route('logout')"
    />

    <!-- Search Dialog Component -->
    <search-dialog v-if="dialog" v-model="dialog" :stand="stand" />

    <!-- Contact Dialog for Mobile -->
    <v-dialog v-model="contactDialog" max-width="400">
      <v-card>
        <v-card-title class="text--text text-uppercase">
          {{ $t("appbar.contacto.titulo") }}
        </v-card-title>
        <v-card-text
          style="background-color: #f2f2f3"
          class="pt-2 scrollable-content"
        >
          <v-list :min-width="300" bg-color="background">
            <!-- expositor -->
            <v-list-subheader class="text-uppercase primary--text">{{
              $t("appbar.contacto.expositor")
            }}</v-list-subheader>

            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="primary" class="me-2">
                  mdi-email-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text"
                >atencionexpositor@expopack.com.mx</v-list-item-title
              >
              <v-list-item-subtitle class="text-caption">{{
                $t("correo")
              }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="primary" class="me-2">
                  mdi-phone-hangup-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text"
                >+52 (55) 5545 4254 ext 128</v-list-item-title
              >
              <v-list-item-subtitle class="text-caption">{{
                $t("telefono")
              }}</v-list-item-subtitle>
            </v-list-item>

            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="primary" class="me-2">
                  mdi-email-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text"
                >atencionexpositor2@expopack.com.mx</v-list-item-title
              >
              <v-list-item-subtitle class="text-caption">{{
                $t("correo")
              }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="primary" class="me-2">
                  mdi-phone-hangup-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text"
                >+52 (55) 5545 4254 ext 127</v-list-item-title
              >
              <v-list-item-subtitle class="text-caption">{{
                $t("telefono")
              }}</v-list-item-subtitle>
            </v-list-item>

            <v-divider class="my-2"></v-divider>

            <!-- pmmi -->
            <v-list-subheader class="primary--text">{{
              $t("appbar.contacto.pmmi")
            }}</v-list-subheader>

            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="secondary" class="me-2">
                  mdi-email-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text">{{
                constants.contactEmail
              }}</v-list-item-title>
              <v-list-item-subtitle class="text-caption">{{
                $t("correo")
              }}</v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <template v-slot:prepend>
                <v-icon size="22" color="secondary" class="me-2">
                  mdi-phone-hangup-outline
                </v-icon>
              </template>

              <v-list-item-title class="text--text">{{
                constants.contactPhone
              }}</v-list-item-title>
              <v-list-item-subtitle class="text-caption">{{
                $t("telefono")
              }}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="d-flex flex-row justify-center"
          ><v-btn
            color="secondary"
            variant="outlined"
            class="font-weight-bold"
            @click="contactDialog = false"
          >
            {{ $t("boton-cerrar") }}
          </v-btn></v-card-actions
        >
      </v-card>
    </v-dialog>

    <!-- MENÚ TABLETA Y MOBILE -->
    <!-- menú formas -->
    <v-menu
      offset-x
      max-width="300"
      :close-on-content-click="false"
      v-model="menuFormas"
    >
      <template #activator="{ props }">
        <circular-icon-button
          icon="mdi-list-box-outline"
          icon-color="secondary"
          v-bind="props"
          class="d-flex d-lg-none d-xl-none"
        />
      </template>
      <!-- menu formas en móvil -->
      <v-list>
        <v-list-group
          v-for="item in menu"
          :key="item.nombre"
          v-model="item.activo"
        >
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props">
              <v-list-item-title
                class="text-body-1"
                style="height: auto !important; white-space: normal !important"
              >
                {{ item.nombre.replace('<br />', ' ') }}
              </v-list-item-title>
            </v-list-item>
          </template>
          <template v-for="forma in item.formas" :key="forma.id">
            <boton-dinamico :forma="forma" :stand="stand" origen="1">
              <template #default="{ accion, attrs }">
                <v-list-item
                  v-bind="attrs"
                  @click="
                    (e) => {
                      accion(e);
                      if (forma.tipo !== 1) {
                        cerrarMenuFormas();
                      }
                    }
                  "
                >
                  <template v-slot:prepend>
                    <v-icon class="ml-5 mr-2">mdi-menu-right</v-icon>
                  </template>
                  <v-list-item-title
                    class="text-body-2"
                    style="
                      height: auto !important;
                      white-space: normal !important;
                    "
                  >
                    {{ forma.nombre }}
                  </v-list-item-title>
                </v-list-item>
              </template>
            </boton-dinamico>
          </template>
        </v-list-group>
      </v-list>
    </v-menu>

    <circular-icon-button
      icon="mdi-magnify"
      icon-color="secondary"
      @click="abrirBuscador"
      class="d-flex d-lg-none d-xl-none"
    />

    <!-- contacto, perfil, cerrar sesión -->
    <v-menu
      offset-x
      max-width="300"
      :close-on-content-click="false"
      v-model="menuEstatus"
    >
      <template v-slot:activator="{ props }">
        <circular-icon-button
          icon="mdi-menu"
          icon-color="secondary"
          v-bind="props"
          class="d-flex d-lg-none d-xl-none"
        />
      </template>
      <v-list>
        <!-- Notificaciones (Mobile) -->
        <!-- <notifications-dialog
          :stand="stand"
          :unread-count="unreadNotifications"
          @unreadCountUpdated="updateUnreadCount"
        >
          <template #activator="{ props: menuProps }">
            <v-list-item v-bind="menuProps" class="customPrepend">
              <template v-slot:prepend>
                <v-badge
                  color="error"
                  :content="unreadNotifications"
                  :model-value="unreadNotifications > 0"
                  overlap
                >
                  <v-icon color="secondary" size="22">mdi-bell-outline</v-icon>
                </v-badge>
              </template>
              <v-list-item-title class="text--text">{{
                $t("appbar.notificaciones")
              }}</v-list-item-title>
            </v-list-item>
          </template>
        </notifications-dialog>

        <v-divider class="my-2"></v-divider>-->

        <!-- Contactos -->
        <v-list-item link @click="abrirContacto" class="customPrepend">
          <template v-slot:prepend>
            <v-icon color="secondary" size="22"
              >mdi-card-account-phone-outline</v-icon
            >
          </template>
          <v-list-item-title class="text--text">{{
            $t("appbar.contacto.titulo")
          }}</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <!-- Cambio Idioma -->
        <v-list-group style="background-color: white">
          <template #activator="{ props }">
            <v-list-item v-bind="props" class="customPrepend">
              <template v-slot:prepend>
                <v-icon color="secondary" size="22"
                  >mdi-translate-variant</v-icon
                >
              </template>
              <v-list-item-title class="text--text">
                <span v-if="locale == 'es'">{{ $t("appbar.espaniol") }}</span>
                <span v-else>{{ $t("appbar.ingles") }}</span>
              </v-list-item-title>
            </v-list-item>
          </template>
          <!-- Spanish -->
          <v-list-item :href="route('locale', 'es')" link class="pl-12">
            <template v-slot:prepend>
              <v-avatar color="secondary" class="white--text" size="32">
                <span style="font-size: 14px; font-weight: bold">ES</span>
              </v-avatar>
            </template>
            <v-list-item-title class="text--text">{{
              $t("appbar.espaniol")
            }}</v-list-item-title>
          </v-list-item>

          <!-- English -->
          <v-list-item :href="route('locale', 'en')" link class="pl-12">
            <template v-slot:prepend>
              <v-avatar color="secondary" class="white--text" size="32">
                <span style="font-size: 14px; font-weight: bold">EN</span>
              </v-avatar>
            </template>
            <v-list-item-title class="text--text">{{
              $t("appbar.ingles")
            }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-divider class="my-2"></v-divider>

        <!-- Cerrar Sesión -->
        <v-list-item link :href="route('logout')">
          <template v-slot:append>
            <v-list-item-title class="text--text pr-2">{{
              $t("appbar.logout")
            }}</v-list-item-title>
            <v-icon color="secondary" size="22">mdi-logout-variant</v-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { usePage, router } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";
import { useMenuStore } from "../../stores/menu.js";
import { constants } from "../../core/constants.js";
import SearchDialog from "./SearchDialog.vue";
//import NotificationsDialog from "./NotificationsDialog.vue";
import CircularIconButton from "./CircularIconButton.vue";
import axios from "axios";
//import Pusher from "pusher-js";
//import Echo from "laravel-echo";

// Store
const menuStore = useMenuStore();

// i18n
const { t: $t, locale } = useI18n();

// Page props
const page = usePage();
const menu = computed(() => page.props.menu);
const stand = computed(() => page.props.stand);
const user = computed(() => page.props.user);
const shortcuts = computed(() => page.props.shortcuts);

// Data
const dialog = ref(false);
const contactDialog = ref(false);
const menuEstatus = ref(false);
const menuFormas = ref(false);
const unreadNotifications = ref(0);

// Template refs
const notificationsDialogRef = ref(null);

// Methods
const abrirBuscador = () => {
  dialog.value = true;
};

const abrirContacto = () => {
  contactDialog.value = true;
  menuEstatus.value = false;
};

const cerrarMenu = () => {
  menuEstatus.value = false;
};

const cerrarMenuFormas = () => {
  menuFormas.value = false;
};

const scrollToBottom = () => {
  const cardTextElement = cardText.value;
  if (cardTextElement) {
    cardTextElement.scrollTop = cardTextElement.scrollHeight;
  } else {
    console.warn("El elemento v-card-text no se pudo encontrar.");
  }
};

const updateUnreadCount = (count) => {
  unreadNotifications.value = count;
};

// Fetch unread notifications count
const getNoLeidas = async () => {
  if (stand.value?.id) {
    try {
      const response = await axios.get(
        route("notificaciones.unread-count", stand.value.id)
      );
      unreadNotifications.value = response.data.unread;
    } catch (error) {
      console.error("Error fetching unread count:", error);
    }
  }
};

// Initialize Echo and fetch initial data
/*onMounted(() => {
  // Fetch initial unread count
  getNoLeidas();

  // Inicializar Echo si no existe
  if (!window.Echo) {
    window.Pusher = Pusher;
    window.Echo = new Echo({
      broadcaster: "pusher",
      host: window.host,
      key: process.env.MIX_PUSHER_APP_KEY,
      wsHost: window.location.hostname,
      wsPort: 6001,
      wssPort: 6001,
      disableStats: true,
      enabledTransports: [
        process.env.MIX_APP_ENV == "production" ? "ws" : "ws",
      ],
      forceTLS: process.env.MIX_APP_ENV == "production" ? false : false,
      encrypted: process.env.MIX_APP_ENV == "production" ? false : false,
      cluster: "mt1",
    });
  }

  // Listen for notifications on the Stand channel
  if (window.Echo && stand.value) {
    window.Echo.private(`App.Models.Stand.${stand.value.id}`).notification(
      (notification) => {
        if (notification.refresh) {
          // Update unread count
          getNoLeidas();

          // If notifications dialog component exists, refresh it
          if (notificationsDialogRef.value) {
            notificationsDialogRef.value.refreshNotifications();
          }
        }
      }
    );
  }
});*/
</script>

<style scoped>
.circular-btn {
  background-color: white !important;
  border-radius: 50% !important;
}

.customPrepend :deep(.v-list-item__prepend .v-list-item__spacer) {
  width: 12px;
}
</style>
